import { render, staticRenderFns } from "./Database_oem.vue?vue&type=template&id=e08b3e1c"
import script from "./Database_oem.vue?vue&type=script&lang=js"
export * from "./Database_oem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports